import { isEqual, negate } from 'lodash/fp';
import { createPortal } from 'react-dom';

import { TOOLBAR_HEIGHT } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateEditorToolbar';
import { TranslationsConfig } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenComponentEditor/ComponentEditorSections/TranslationsEditor';
import TranslationInputs from 'dashboard/apps/InquiryTemplateEditor/TranslationInputs';
import MaximizablePanel from 'dashboard/components-lib/MaximizablePanel';
import { FULL_SCREEN_HEADER_HEIGHT_XS } from 'dashboard/layouts/ShowViewLayoutV2';
import { INQUIRY_TEMPLATE_EDITOR_SHOW_VIEW_ID } from 'dashboard/views/DashboardInquiryTemplatesShowView/DashboardInquiryTemplatesShowView';
import { InquiryIso6391LanguageCode } from 'lib/constants/locales';

interface TranslationsPanelProps {
  config: TranslationsConfig;
  currentLocale: InquiryIso6391LanguageCode;
  enabledLocales: InquiryIso6391LanguageCode[];
  offsetElementId: string;
  editable: boolean;
  getStepLocalizedStrings: (locales?: Array<InquiryIso6391LanguageCode>) => Promise<void>;
  handleTranslationUpdates: (componentConfigUpdates: Record<string, any>) => void;
  onChange?: (value: string, locale: InquiryIso6391LanguageCode, path: string) => void;
  onOutsideClick: () => void;
}

const TranslationsPanel = ({
  config,
  currentLocale,
  enabledLocales,
  offsetElementId = 'ite-control-panel__container',
  editable,
  getStepLocalizedStrings,
  handleTranslationUpdates,
  onOutsideClick,
}: TranslationsPanelProps) => {
  return createPortal(
    <MaximizablePanel
      title='Translations'
      offsetElementId={offsetElementId}
      fullscreenTop={FULL_SCREEN_HEADER_HEIGHT_XS + TOOLBAR_HEIGHT}
      onOutsideClickAndEscPress={onOutsideClick}
    >
      <TranslationInputs
        config={config}
        currentLocale={currentLocale}
        enabledLocales={enabledLocales?.filter(negate(isEqual(currentLocale)))}
        editable={editable}
        handleTranslationUpdates={handleTranslationUpdates}
        showCurrentLocale={false}
        getStepLocalizedStrings={getStepLocalizedStrings}
      />
    </MaximizablePanel>,
    document.getElementById(INQUIRY_TEMPLATE_EDITOR_SHOW_VIEW_ID) as Element,
  );
};

export default TranslationsPanel;
